import TerminalEdit from './TerminalEdit'

export default TerminalEdit;